import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	flagHeader: {
		defaultMessage: 'Review your custom colors',
		id: 'custom-theme-admin-flag.flag-header',
		description: 'Flag header if custom nav bar color is detected and the user is an admin',
	},
	flagBody: {
		defaultMessage:
			"You've customized the look and feel of your Jira. Some people may notice mismatched colors when using the new dark theme.",
		id: 'custom-theme-admin-flag.flag-body',
		description: 'Flag body if custom nav bar color is detected and the user is an admin',
	},
	revertButton: {
		defaultMessage: 'Revert custom colors',
		id: 'custom-theme-admin-flag.revert-button',
		description: 'Flag button to navigate to Jira Look and Feel settings page',
	},
	learnMoreButton: {
		defaultMessage: 'Learn more',
		id: 'custom-theme-admin-flag.learn-more-button',
		description: 'Flag button to learn more page',
	},
});
